import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectUser, selectAuthLoading, selectIsAuthenticated, selectIsSuperAdmin, selectIsCompanyAdmin } from '../../store/authSlice';
import { canAccessPermission } from '../../config/permissions';

const ProtectedRoute = ({ children, requireSuperAdmin = false, requireCompanyAdmin = false, requiredPermission = null }) => {
    const user = useSelector(selectUser);
    const loading = useSelector(selectAuthLoading);
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const isSuperAdmin = useSelector(selectIsSuperAdmin);
    const isCompanyAdmin = useSelector(selectIsCompanyAdmin);
    const location = useLocation();

    if (loading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100vh'
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requireSuperAdmin && !isSuperAdmin) {
        return <Navigate to="/dashboard" replace />;
    }

    if (requireCompanyAdmin && !isCompanyAdmin && !isSuperAdmin) {
        return <Navigate to="/dashboard" replace />;
    }

    if (requiredPermission && !canAccessPermission(user, requiredPermission)) {
        const fallbackRoute = [
            { path: '/dashboard', permission: 'dashboard.view' },
            { path: '/conversations', permission: 'conversations.view' },
            { path: '/instructions', permission: 'instructions.view' },
            { path: '/staff', permission: 'staff.view' },
            { path: '/items', permission: 'items.view' }
        ].find((route) => canAccessPermission(user, route.permission));

        return <Navigate to={fallbackRoute?.path || '/chatbot'} replace />;
    }

    return children;
};

export default ProtectedRoute;
